import { Component, OnInit } from '@angular/core';
import { HxCategoryService, HxRecipeService, HxSafeHtmlPipe, HxUiLabelPipe, PagedList, WorkflowModel, WorkflowStepModel } from 'hx-services';
import { ActivatedRoute, Data, Router, RouterLink } from '@angular/router';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { TranslocoDirective, TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { HxPagedListDirective } from 'hx-components';
import { firstValueFrom } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { NzAffixComponent } from 'ng-zorro-antd/affix';
import { HxBreadcrumbsComponent } from '@adm-web-app/components/breadcrumbs/breadcrumbs.component';
import { NzPageHeaderComponent, NzPageHeaderExtraDirective, NzPageHeaderSubtitleDirective, NzPageHeaderTitleDirective } from 'ng-zorro-antd/page-header';
import { NzButtonComponent, NzButtonGroupComponent } from 'ng-zorro-antd/button';

import { NzIconDirective } from 'ng-zorro-antd/icon';
import { NzTableCellDirective, NzTableComponent, NzTbodyComponent, NzTheadComponent, NzThMeasureDirective, NzTrDirective } from 'ng-zorro-antd/table';
import { NgFor } from '@angular/common';
import { NzWaveDirective } from 'ng-zorro-antd/core/wave';
import { NzPopconfirmDirective } from 'ng-zorro-antd/popconfirm';

@Component({
    selector: 'hc-workflow-step-list',
    templateUrl: './workflow-step-list.component.html',
    styleUrls: ['./workflow-step-list.component.less'],
  imports: [TranslocoDirective, NzAffixComponent, HxBreadcrumbsComponent, NzPageHeaderComponent, NzPageHeaderTitleDirective, NzPageHeaderSubtitleDirective, NzPageHeaderExtraDirective, NzButtonComponent, RouterLink, NzIconDirective, NzTableComponent, NzTheadComponent, NzTrDirective, NzTableCellDirective, NzThMeasureDirective, NzTbodyComponent, NgFor, NzButtonGroupComponent, NzWaveDirective, NzPopconfirmDirective, HxUiLabelPipe, HxSafeHtmlPipe, TranslocoPipe]
})
export class WorkflowStepListComponent extends HxPagedListDirective<WorkflowStepModel> implements OnInit {

  model!: WorkflowModel;
  filter: {
    page?: number;
    limit?: number;
    query?: string;
  } = {};

  constructor(
    override router: Router,
    override aRoute: ActivatedRoute,
    protected api: HxRecipeService,
    protected notification: NzNotificationService,
    protected tr: TranslocoService,
    protected categoryService: HxCategoryService,
  ) {
    super(router, aRoute);
    this.limit = 20;
  }

  ngOnInit() {
    const routeData: Data = this.aRoute.snapshot.data;
    this.model = routeData['model'] as WorkflowModel;
    this.aRoute.queryParamMap.pipe(takeUntil(this.$destroyed))
      .subscribe(paramMap => {
        const asNumberFn = (name: string, def?: number) => paramMap.get(name) ? Number(paramMap.get(name)) : def;
        this.filter.query = paramMap.get('query') ?? undefined;
        super.load(paramMap);
      });
  }

  async remove(id: number): Promise<void> {
    await this.api.removeWorkflowStep(this.model.id, id);
    this.loadData();
    this.notification.success(this.tr.translate('nav.WorkflowSteps'), this.tr.translate('nt.dataRemoved'));
  }

  protected loadList(): Promise<PagedList<WorkflowStepModel>> {
   return this.api.getWorkflowStepList(this.model.id, {limit: 1000});
  }
}
